import Section_3 from './Section_3';

export default Section_3;